import React, { memo } from "react";
import "./PlaceholderActions.css";

export const PlaceholderActions = memo(() => (
    <div className="PlaceholderActions loading-dots">
        <span className="loading-dot dot-one">.</span>
        <span className="loading-dot dot-two">.</span>
        <span className="loading-dot dot-three">.</span>
    </div>
));
